import React, { ReactNode } from "react";
import { motion } from "framer-motion";
export default function MainSharedComponent({
    title,
    description,
    htmlDescription,
    icon,
}: {
    title: string;
    description?: string;
    htmlDescription?: ReactNode;
    icon: ReactNode;
}) {
    return (
        <motion.li
            transition={{ duration: 1.5 }}
            initial={{ opacity: 0, y: 150 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className={` 3xl:w-[700px] lg:w-[500px] `}
        >
            <span>{icon}</span>
            <h2
                className={
                    "text-[#37367D] 3xl:text-4xl 3xl:leading-[3.5rem] text-lg lg:text-2xl lg:leading-10 mt-7 font-bold"
                }
            >
                {title}
            </h2>
            {description && (
                <p
                    className={
                        "3xl:text-2xl 3xl:leading-10 lg:text-lg lg:leading-8 mt-5 font-light"
                    }
                >
                    {description}
                </p>
            )}
            {htmlDescription && (
                <div
                    className={
                        "3xl:text-2xl 3xl:leading-10 lg:text-lg lg:leading-8 mt-5 font-light"
                    }
                >
                    {htmlDescription}
                </div>
            )}
        </motion.li>
    );
}
